
import { NoseurObject } from "@rivtn/noseur";
import { PloutousBaseService, PloutousTransactionChargeTrail } from "./PloutousBaseService";

export interface ITransactionCharge {
    status: number;
    external_id: string;
    payment_method: string;
    transaction_id: string;
    trails: PloutousTransactionChargeTrail[];
    extra_data: {
        payment_processor_name: string;
    }
}

export interface IManagedTransactionCharge {
    url: string;
}

export class TransactionChargeService extends PloutousBaseService {

    protected static instance: TransactionChargeService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!TransactionChargeService.instance) TransactionChargeService.instance = new TransactionChargeService();
        return TransactionChargeService.instance;
    }

    queryTransactionCharges(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/api/v1/transaction/charge", { query: this.normalizeParams(params) }));
    }

}
